import Vue from 'vue';
import Router from 'vue-router';
import Landing from './views/Landing.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Landing
    },
    {
      path: '/quiz',
      redirect: { name: 'quiz', params: { page: '1' } }
    },
    {
      path: '/quiz/:page',
      name: 'quiz',
      component: () => import('./views/Quiz.vue'),
      props: true
    },
    {
      path: '/results',
      name: 'results',
      component: () => import('./views/Results.vue'),
      props: true
    },
    {
      path: '/details',
      name: 'printer-details',
      component: () => import('./views/PrinterDetails.vue'),
      props: true
    },
    {
      path: '*',
      name: '404',
      redirect: 'home'
    }
  ]
});
